import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=2d534c7d"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"
import style0 from "./Employee.vue?vue&type=style&index=0&id=2d534c7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports